import { makeVar } from '@apollo/client';
import { FilterArrayType } from 'common/components/Filters';
import { ColumnData } from 'common/components/SearchBar';
import { SortOrder } from 'common/utils/commonTypes';

export interface PayCycleListState {
  searchValue?: string | null;
  searchFilters?: FilterArrayType[];
  sortOrderParam?: SortOrder;
  gridColumns?: ColumnData[];
}

// keyed by 'Signing' | 'Accounting' | 'History'
export const payCycleListState = makeVar<Record<string, PayCycleListState>>({});

export const getPayCycleState = (mode: string): PayCycleListState =>
  payCycleListState()[mode] ?? {};

export const savePayCycleState = (
  mode: string,
  patch: Partial<PayCycleListState>
) =>
  payCycleListState({
    ...payCycleListState(),
    [mode]: { ...getPayCycleState(mode), ...patch },
  });

export const clearPayCycleState = () => payCycleListState({});

export const keepPayCycleStateOnExit = makeVar<boolean>(false);